import { useEffect, useState } from 'react'
import axiosClient from '../../config/axios-client'
import MineralsTableLoading from '../../components/ui/loadings/MineralsTableLoading'
import { Link } from 'react-router-dom'
import { PiFilesFill } from 'react-icons/pi'
import moment from 'moment'
import 'moment/locale/ar-kw' // Import Arabic locale
import Breadcrumb from '../../features/core/components/UI/Breadcrumb'
moment.locale('ar-kw')

const links = [
  {
    id: 1,
    label: 'بيانات المعادن بالمنطقة العربية',
    isActive: true,
    to: '/sponsors',
  },
]
export default function CountriesUsersPage() {
  const [countriesUsers, setCountriesUsers] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const getcountriesUsers = async () => {
    setIsLoading(true)

    axiosClient
      .get(`/dashboard/form/countries_users`)
      .then(({ data }) => {
        setCountriesUsers(data.countries_users)
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getcountriesUsers()
  }, [])

  return (
    <>
      <div className="">
        <div className="mb-4 flex justify-between">
          <div>
            {/* <h2 className="text-primary-600 text-lg font-bold">
              بيانات المعادن بالمنطقة العربية
            </h2> */}
            <Breadcrumb links={links} />
          </div>
        </div>

        <div className="mb-64">
          <table className="w-full">
            <thead>
              <tr className="border-2 border-primary-600 bg-primary-600 text-center text-white">
                <th className="p-3 px-4 text-start">الدولة</th>
                <th className="p-3 px-4 text-right">الجهة المعنية</th>
                <th className="p-3 px-4 text-right">الأسم الكامل </th>
                <th
                  className="p-3 px-4 text-right"
                  dir=""
                >
                  التاريخ
                </th>
                <th className="p-3 px-4 text-center">عدد الملفات</th>
                <th className="p-3 px-4"></th>
              </tr>
            </thead>
            <tbody>
              {countriesUsers &&
                countriesUsers.map((user) => {
                  return (
                    <tr className="border-top-none bg-light group border-2 text-center odd:bg-white">
                      <td className="group-hover:bg-muted/50 p-2 px-4 text-start">
                        {user?.country?.name_ar}
                      </td>
                      <td className="group-hover:bg-muted/50 p-2 px-4 text-right">
                        {user?.title}
                      </td>
                      <td className="group-hover:bg-muted/50 p-2 px-4 text-right">
                        {user?.full_name}
                      </td>
                      <td className="group-hover:bg-muted/50 p-2 px-4 text-right">
                        {moment(user?.created_at).format('LL')}
                      </td>
                      <td className="group-hover:bg-muted/50 p-2 px-4 text-center">
                        {user?.files?.length}
                      </td>
                      <td className="group-hover:bg-muted/50 p-2 px-4">
                        <Link
                          to={`${user.id}`}
                          className="bg-light border-muted group-hover:bg-muted relative m-auto inline-flex w-fit items-center border-2 p-2 text-center text-primary-600"
                        >
                          <PiFilesFill size={22} />
                        </Link>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
